// ═══════════════════════════════════════════════════════════════════════════
// services/crmWorkflowService.js
// Servicios específicos para el WORKFLOW del pipeline
// NO reemplaza crmService.js, es complementario
// ═══════════════════════════════════════════════════════════════════════════

import api from './api';

const CRM_BASE = '/crm';

// ═══════════════════════════════════════════════════════════════════════════
// TRANSICIONES DE ETAPA
// ═══════════════════════════════════════════════════════════════════════════

export const transicionarEtapa = (oportunidadId, etapaDestino, datos, motivo) => {
  return api.post(`${CRM_BASE}/oportunidades/${oportunidadId}/transicion`, {
    etapa_destino: etapaDestino,
    datos: datos,
    motivo: motivo
  });
};

export const convertirAProyecto = (oportunidadId) => {
  return api.post(`${CRM_BASE}/oportunidades/${oportunidadId}/convertir-proyecto`);
};

export const getWorkflowConfig = () => {
  return api.get(`${CRM_BASE}/workflow-config`);
};

export const getEstadisticasPipeline = () => {
  return api.get(`${CRM_BASE}/pipeline/estadisticas`);
};

// CATÁLOGOS PARA PROPUESTAS (reutilizando módulo de proyectos)
export const cargarPartidasEstandar = () => {
  return api.get('/partidas-estandar');
};

export const cargarCategoriasPartida = () => {
  return api.get('/categorias-partida');
};
// ═══════════════════════════════════════════════════════════════════════════
// CONFIGURACIÓN DEL WORKFLOW (Frontend)
// ═══════════════════════════════════════════════════════════════════════════

export const WORKFLOW_CONFIG = {
  contacto_inicial: {
    nombre: 'Contacto Inicial',
    color: '#3b82f6',
    bgColor: '#dbeafe',
    icono: '📞',
    siguiente: 'necesidad_validada',
    tiempoMaximoDias: 3,
    descripcion: 'Primer contacto con el prospecto'
  },
  necesidad_validada: {
    nombre: 'Necesidad Validada',
    color: '#8b5cf6',
    bgColor: '#ede9fe',
    icono: '🔍',
    anterior: 'contacto_inicial',
    siguiente: 'propuesta_enviada',
    tiempoMaximoDias: 7,
    descripcion: 'Se validaron los requerimientos técnicos'
  },
  propuesta_enviada: {
    nombre: 'Propuesta Enviada',
    color: '#f59e0b',
    bgColor: '#fef3c7',
    icono: '📄',
    anterior: 'necesidad_validada',
    siguiente: 'negociacion',
    tiempoMaximoDias: 14,
    descripcion: 'Propuesta formal entregada al cliente'
  },
  negociacion: {
    nombre: 'En Negociación',
    color: '#ec4899',
    bgColor: '#fce7f3',
    icono: '🤝',
    anterior: 'propuesta_enviada',
    siguiente: ['cerrado_ganado', 'cerrado_perdido'],
    tiempoMaximoDias: 21,
    descripcion: 'Negociación de términos y condiciones'
  },
  cerrado_ganado: {
    nombre: 'Cerrado - Ganado',
    color: '#10b981',
    bgColor: '#d1fae5',
    icono: '✅',
    anterior: 'negociacion',
    descripcion: 'Oportunidad convertida en proyecto'
  },
  cerrado_perdido: {
    nombre: 'Cerrado - Perdido',
    color: '#ef4444',
    bgColor: '#fee2e2',
    icono: '❌',
    anterior: ['contacto_inicial', 'necesidad_validada', 'propuesta_enviada', 'negociacion'],
    descripcion: 'Oportunidad no concretada'
  }
};

// Helper para obtener el siguiente paso permitido
export const getSiguienteEtapa = (etapaActual) => {
  return WORKFLOW_CONFIG[etapaActual]?.siguiente || null;
};

// Helper para validar si una transición es permitida
export const esTransicionValida = (desde, hacia) => {
  const permitidas = WORKFLOW_CONFIG[desde]?.siguiente || [];
  return Array.isArray(permitidas) 
    ? permitidas.includes(hacia)
    : permitidas === hacia;
};

// Helper para calcular alertas de tiempo
export const getAlertaTiempo = (oportunidad) => {
  const config = WORKFLOW_CONFIG[oportunidad.etapa];
  if (!config?.tiempoMaximoDias) return null;
  
  const diasEnEtapa = Math.floor(
    (new Date() - new Date(oportunidad.actualizado_en)) / (1000 * 60 * 60 * 24)
  );
  
  if (diasEnEtapa > config.tiempoMaximoDias) {
    return { tipo: 'error', mensaje: `Excedió límite de ${config.tiempoMaximoDias} días` };
  }
  if (diasEnEtapa > config.tiempoMaximoDias * 0.8) {
    return { tipo: 'warning', mensaje: `Próximo a límite (${diasEnEtapa}/${config.tiempoMaximoDias} días)` };
  }
  return null;
};
export const prepararDatosProyecto = (oportunidad) => {
  return {
    nombre: `Proyecto: ${oportunidad.prospecto?.nombre || 'Nueva Oportunidad'}`,
    cliente_id: oportunidad.cliente_id,
    descripcion: oportunidad.notas || '',
    fecha_inicio: new Date().toISOString().split('T')[0]
  };
};

export const crearProyectoDesdeOportunidad = async (oportunidadId, datos) => {
  console.log("Creando proyecto para OP:", oportunidadId, datos);
  // Aquí irá tu llamada al backend: return axios.post(...)
  return { success: true, data: { id: 100 } };
};

export const guardarProgresoEtapa = async (oportunidadId, datos) => {
  console.log("Guardando progreso intermedio:", oportunidadId, datos);
  // Esta función guarda los datos del BANT o Propuesta sin mover la etapa todavía
  return { success: true };
};

export const iniciarTransicionEtapa = async (oportunidadId, etapaDestino) => {
  console.log("Iniciando flujo hacia:", etapaDestino);
  return { success: true };
};